 
import { Directive, ElementRef, OnInit, Input, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[errorLabel]',
  standalone: true,
})
export class ErrorLabelDirective implements OnInit {
  //private htmlElement!: ElementRef<HTMLElement>;
  private _colorClass = 'c-text--danger';
  private _errors?: ValidationErrors | null | undefined = null;
  private htmlElement = inject<ElementRef<HTMLElement>>(ElementRef);
  @Input() title = '';

  @Input() set colorClass(value: string) {
    this._colorClass = value;
    this.setStyle();
  }

  @Input() set errors(value: ValidationErrors | null | undefined) {
    this._errors = value;
    this.setErrorMessage();
  }

  /* constructor(private el: ElementRef<HTMLElement>) {
    this.htmlElement = el;
  } */

  ngOnInit() {
    this.setStyle();
  }

  setStyle() {
    if (!this.htmlElement) return;
    this.htmlElement.nativeElement.classList.add(this._colorClass);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isNumber(value: any): value is number {
    return !Number.isNaN(this.toInteger(value));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toInteger(value: any): number {
    return Number.parseInt(`${value}`, 10);
  }

  padNumber(value: number) {
    return this.isNumber(value) ? `0${value}`.slice(-2) : '';
  }

   
  setErrorMessage() {
    // console.log('this._errors', this._errors);
    if (!this.htmlElement) return;
    if (!this._errors) {
      this.htmlElement.nativeElement.innerText = '';
      return;
    }

    const errors = Object.keys(this._errors);

    if (errors.includes('required')) {
      this.htmlElement.nativeElement.innerText = `${this.title || 'El campo'} es requerido`;
      return;
    }

    if (errors.includes('hasNumber')) {
      this.htmlElement.nativeElement.innerText = `${this.title || 'El campo'} debe tener al menos un número`;
      return;
    }

    if (errors.includes('hasCapitalCase')) {
      this.htmlElement.nativeElement.innerText = `${this.title || 'El campo'} debe tener al menos una mayúscula`;
      return;
    }

    if (errors.includes('hasSmallCase')) {
      this.htmlElement.nativeElement.innerText = `${this.title || 'El campo'} debe tener al menos una minúscula`;
      return;
    }

    if (errors.includes('hasSpecialCharacters')) {
      this.htmlElement.nativeElement.innerText = `${this.title || 'El campo'} debe tener al menos un caracter especial`;
      return;
    }

    if (errors.includes('email')) {
      this.htmlElement.nativeElement.innerText = `${this.title || 'El campo'} debe ser un correo`;
      return;
    }

    if (errors.includes('PasswordNoMatch')) {
      this.htmlElement.nativeElement.innerText = 'Las contraseñas ingresadas no coinciden';
      return;
    }

    if (errors.includes('EmailNoMatch')) {
      this.htmlElement.nativeElement.innerText = 'Los correos ingresados no coinciden';
      return;
    }

    if (errors.includes('pattern')) {
      this.htmlElement.nativeElement.innerText = 'Combinaciones de caracteres no permitidas';
      return;
    }

    if (errors.includes('minlength')) {
      const min = this._errors['minlength'].requiredLength;
      const current = this._errors['minlength'].actualLength;

      this.htmlElement.nativeElement.innerText = `${
        this.title || 'El campo'
      } debe tener mínimo ${current}/${min} caracteres`;
      return;
    }

    if (errors.includes('maxlength')) {
      const max = this._errors['maxlength'].requiredLength;
      const current = this._errors['maxlength'].actualLength;

      this.htmlElement.nativeElement.innerText = `${
        this.title || 'El campo'
      } debe tener máximo ${current}/${max} caracteres`;
      return;
    }

    if (errors.includes('ngbDate')) {
      const ngbDate = this._errors['ngbDate'];

      const ngbDateErrors = Object.keys(this._errors['ngbDate']);

      if (ngbDateErrors.includes('invalid')) {
        this.htmlElement.nativeElement.innerText = `${this.title || 'El campo'} debe ser una fecha válida`;
        return;
      }

      if (ngbDateErrors.includes('minDate')) {
        this.htmlElement.nativeElement.innerText = `${
          this.title || 'El campo'
        } debe ser mayor o igual a la fecha ${this.padNumber(ngbDate.minDate.minDate.day)}/${this.padNumber(
          ngbDate.minDate.minDate.month
        )}/${ngbDate.minDate.minDate.year}`;
        return;
      }

      if (ngbDateErrors.includes('maxDate')) {
        this.htmlElement.nativeElement.innerText = `${
          this.title || 'El campo'
        } debe ser menor o igual a la fecha ${this.padNumber(ngbDate.maxDate.maxDate.day)}/${this.padNumber(
          ngbDate.maxDate.maxDate.month
        )}/${ngbDate.maxDate.maxDate.year}`;
        return;
      }
    }

    this.htmlElement.nativeElement.innerText = '';
  }
}
